var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "schematic-img-box"
  }, [_vm._l(_vm.imgArr, function (img, index) {
    return _c("div", {
      key: img,
      staticClass: "image-item"
    }, [_c("wlc-image", {
      ref: "image_".concat(index),
      refInFor: true,
      attrs: {
        src: img,
        current: index,
        list: _vm.imgArr,
        width: "76",
        compression: true
      }
    }), _c("div", {
      staticClass: "icon-group"
    }, [_c("i", {
      staticClass: "fa fa-eye",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.previewImage(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-close",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.removeImg(index);
        }
      }
    })])], 1);
  }), _c("wlc-upload-image", {
    attrs: {
      visible: false,
      disabled: _vm.imgArr.length >= _vm.max,
      url: _vm.imgUrl,
      multimediaType: "customerService"
    },
    on: {
      "update:url": function updateUrl($event) {
        _vm.imgUrl = $event;
      }
    }
  }), _c("el-dialog", {
    staticClass: "wlc-image-preview",
    attrs: {
      top: "5vh",
      fullscreen: true,
      visible: _vm.previewDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.previewDialogVisible = $event;
      }
    }
  }, [_c("el-carousel", {
    ref: "carousel",
    attrs: {
      "indicator-position": "none",
      autoplay: false,
      arrow: "always"
    }
  }, _vm._l(_vm.imgArr, function (item, index) {
    return _c("el-carousel-item", {
      key: index
    }, [_c("img", {
      staticStyle: {
        width: "100%",
        height: "100%",
        "object-fit": "contain"
      },
      attrs: {
        src: item
      }
    })]);
  }), 1)], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };